"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUserChannels = exports.USE_USER_CHANNELS_KEY = void 0;
var types_1 = require("../types");
var usePaginatedModel_1 = __importDefault(require("./usePaginatedModel"));
exports.USE_USER_CHANNELS_KEY = 'users/message-channels';
var useUserChannels = function (channelId) {
    var res = (0, usePaginatedModel_1.default)(exports.USE_USER_CHANNELS_KEY, {
        page: 1,
        limit: 100,
        order_by: 'updated_at',
        direction: types_1.PAGINATION_DIRECTION.DESC,
        stream_channel_id: channelId,
    }, {
        queryConfig: {
            refetchOnMount: true,
            refetchOnReconnect: true,
        },
    });
    return res;
};
exports.useUserChannels = useUserChannels;
exports.default = exports.useUserChannels;
//# sourceMappingURL=useUserChannels.js.map